function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { shouldSeeProductsPricingPage, shouldSeeV10PricingVersion } from "services/ab-tests/monetization-ab-tests-service";
import { withGenericConfig } from "contexts/generic-config-context";
import { withAbTests } from "contexts/ab-tests-context";
import DefaultProps from "./default-props";
import ProductPriceAndFeaturesCards from "./product-prices-and-features-cards/product-prices-and-features-cards-component";
import PriceCardsComponent from "./components/price-cards/price-cards-component";
import { shouldHideBasicTier, shouldSeeNewPricing } from "services/pricing-service";
import { CRM } from "constants/clusters";
class PricesAndFeaturesCardsPricingComponent extends PureComponent {
    componentDidUpdate() {
        this.checkIfShouldSeeProductsFeaturesTable();
    }
    checkIfShouldSeeProductsFeaturesTable() {
        const { productName, abTests, clusterId, hasStudentPlan, cookies, forcePricing, cloudfrontViewerCountry, isClusterMiniSitePage } = this.props;
        this.shouldSeeProductsFeaturesTable = productName && (isClusterMiniSitePage || shouldSeeProductsPricingPage({
            abTests,
            clusterId,
            hasStudentPlan,
            cookies,
            forcePricing,
            cloudfrontViewerCountry
        }));
        // only used to emit bigbrain event
        shouldSeeV10PricingVersion({
            cookies,
            forcePricing,
            abTests
        });
    }
    render() {
        const { isHomepagePricing, clusterId, abTests, simulateNewPricingTest, productName, persistantCookies, forceSunsetBasic, unitOfMeasure } = this.props;
        // When productize handle the case that product name not always match to cluster, it works for CRM but for core not
        const isNewPricing = simulateNewPricingTest && productName === CRM || this.props.isNewPricing || shouldSeeNewPricing(productName, abTests);
        // for tiers
        const hideBasicTier = shouldHideBasicTier({
            persistantCookies,
            clusterId,
            productName,
            abTests,
            forceSunsetBasic
        });
        // rendering another component because we need access to ab tests as well.
        if (this.shouldSeeProductsFeaturesTable || isHomepagePricing) {
            return /*#__PURE__*/ _jsx(ProductPriceAndFeaturesCards, _object_spread_props(_object_spread({}, this.props), {
                isNewPricing: isNewPricing,
                shouldHideBasicTier: hideBasicTier,
                unitOfMeasure: unitOfMeasure
            }));
        }
        return /*#__PURE__*/ _jsx(PriceCardsComponent, _object_spread({}, this.props));
    }
    constructor(props){
        super(props);
        this.checkIfShouldSeeProductsFeaturesTable();
    }
}
export default withAbTests(withGenericConfig(PricesAndFeaturesCardsPricingComponent));
PricesAndFeaturesCardsPricingComponent.defaultProps = DefaultProps;
